import React from "react";
import { useDispatch } from "react-redux";
import { FMarketListData } from "../types";
import { setSecurity, setSecuritySymbol, setSecurityName } from "../marketsDataSlice";
import { loadMarketAllData } from "../../mainBoard/thunks/loadMarketAllData";

export const useMarketSecurityData = () => {
    const dispatch = useDispatch();
	return React.useCallback((security: FMarketListData) => {
            dispatch(setSecurity(security.securityId));
            dispatch(setSecuritySymbol(security.symbol));
            dispatch(setSecurityName(security.name));
            dispatch(loadMarketAllData());
        },
        [dispatch]
    );
};


